import React, { useEffect, useRef } from 'react';
import loadScript from 'lib/loadScript';

/**
 * NbcAffiliatesVideoLegacy component renders a container for embedding NBC affiliate videos.
 * @param {object} props - The component props.
 * @param {import('../../../../lib/graphqlTypeDefs.mjs').Widget} props.widget - The component props containing the widget object.
 * @returns {JSX.Element} The rendered component.
 */
const NbcAffiliatesVideoLegacy = ({ widget }) => {
  const elemRef = useRef(null);

  useEffect(() => {
    // loading the script this way since their script (annoyingly) uses the script tag's
    // parent container to determine where the iframe should be inserted
    if (widget.properties?.['video-source']) {
      loadScript(widget.properties['video-source'], { location: elemRef.current });
    }
  }, [widget]);

  return (
    <div
      className="embed-widget__use-presentation"
      data-testid="nbc-affiliates-video-legacy"
      ref={elemRef}
    />
  );
};

export const MemoizedNbcAffiliatesVideoLegacy = React.memo(NbcAffiliatesVideoLegacy, () => false);

